import React from "react";
import styled from "@emotion/styled";
import { Typography, IconButton, Box } from "@mui/material";
import SuccessSvg from "@icons/myicons/check-circle-filled.svg?react";
import WarningIcon from "@icons/myicons/warning-circle-filled.svg?react";
import DeleteIcon from "@icons/myicons/trash-bin-delete.svg?react";
import { Tooltip } from "@components";
import { UniqueParsingResult } from "./ParsingResult";

const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing()};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export interface Props {
  testid?: string;
  parsingResult: UniqueParsingResult;
  onRemove: (parsingResult: UniqueParsingResult) => void;
}

export const UploadedFile = ({ parsingResult, testid, onRemove }: Props) => {
  return (
    <Container data-testid={testid || "uploaded-file"}>
      {parsingResult.successful && parsingResult.activities?.length && (
        <Box color="icon.success" display="flex" alignItems="center">
          <SuccessSvg />
        </Box>
      )}
      {(!parsingResult.successful || !parsingResult.activities?.length) && (
        <Tooltip
          text={parsingResult.error ? parsingResult.error : ""}
          placement="top"
          isSmall
        >
          <Box color="error.dark" display="flex" alignItems="center">
            <WarningIcon fontSize="small" />
          </Box>
        </Tooltip>
      )}

      <Typography variant="body3" noWrap>
        {parsingResult.file.name}
      </Typography>

      <IconButton
        size="small"
        onClick={() => {
          onRemove(parsingResult);
        }}
      >
        <DeleteIcon />
      </IconButton>
    </Container>
  );
};
